import "./FooterSectionIcon.css";

const FooterSectionIcon = () => {
  return (
    <section className="footer-section-icon">
      <div className="footer-col-m-d">
        <div className="phone-number">
          <div className="phone-number-inner">
            <div className="contact-arrowa4cb5823svg-parent">
              <img
                className="contact-arrowa4cb5823svg-icon3"
                loading="eager"
                alt=""
                src="/contactarrowa4cb5823svg1.svg"
              />
              <div className="copyright-info">
                <div className="stay-connected1">Stay connected</div>
              </div>
            </div>
          </div>
          <h1 className="heading-17">Partnership</h1>
        </div>
        <div className="welcome-to-our-container">
          <p className="welcome-to-our">
            Welcome to our "Partner with Us" page! We are excited to offer you
            the
          </p>
          <p className="opportunity-to-become">
            opportunity to become a reseller of our cutting-edge eSIM products
            for
          </p>
          <p className="travel">travel.</p>
        </div>
      </div>
    </section>
  );
};

export default FooterSectionIcon;
